import React from 'react';
import { UseFormReset } from 'react-hook-form';
import { Button } from 'reactstrap';
import { DeactivateUserFormValues } from '..';

interface PropTypes {
  onClose: (close: boolean) => void;
  isValid: boolean;
  reset: UseFormReset<DeactivateUserFormValues>;
}

export function ButtonsRow(props: PropTypes) {
  const handleClose = () => {
    props.onClose(false);
    props.reset();
  };

  return (
    <div className='d-flex justify-content-end'>
      <Button className='me-2' color='secondary' onClick={() => handleClose()}>
        Cancel
      </Button>
      <Button color='danger' type='submit' disabled={!props.isValid}>
        Deactivate
      </Button>
    </div>
  );
}
